import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { Account, FollowItem, SmallProfileInfo, Suscription, User } from '../interfaces/user.model';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private isSuscriptor = new BehaviorSubject<boolean>(false);
  private polenta_url: string = '';

  public suscripto$ = this.isSuscriptor.asObservable();

  constructor(private http: HttpClient, private auth: AuthService) { }

  getAccountNoRedirect(): Promise<User> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      this.http.get(`${environment.apiEndpoint}/Account/Get`, { headers }).subscribe(
        (resp: any) => {
          if (resp) this.isSuscriptor.next(resp.suscription ? true : false);
          else this.isSuscriptor.next(false);
          resolve(resp);
        },
        (error) => {
          this.isSuscriptor.next(false);
          reject(error);
        },
      );
    });
  }

  getAccount(redirect = false): Promise<User> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      this.http.get(`${environment.apiEndpoint}/Account/Get`, { headers }).subscribe(
        (resp: any) => {
          if (resp) this.isSuscriptor.next(resp.suscription ? true : false);
          else this.isSuscriptor.next(false);

          resolve(resp);
        },
        (error) => {
          this.isSuscriptor.next(false);

          if (redirect) {
            this.auth.logout('/' + redirect);
          } else {
            this.auth.logout();
          }

          reject(error);
        },
      );
    });
  }

  getAccountNoEvent(redirect = false): Promise<User> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      this.http.get(`${environment.apiEndpoint}/Account/Get`, { headers }).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          if (redirect) {
            this.auth.logout('/' + redirect);
          } else {
            this.auth.logout();
          }
          reject(error);
        },
      );
    });
  }

  getAccountById(id: number): Promise<User> {
    return new Promise((resolve, reject) => {
      let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);

      this.http.get(`${environment.apiEndpoint}/Account/GetByIdWeb/${id}`, { headers }).subscribe(
        (resp: any) => {
          resolve(resp);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  cancelSuscription(sub: Suscription) {
    let headers = new HttpHeaders().set('Authorization', `Bearer ${this.auth.leerToken().token}`);
    return this.http.post(`${environment.apiEndpoint}/Account/CancelSubscription/` + sub.id, {}, { headers });
  }

  get isSuscriptorValue(): boolean {
    return this.isSuscriptor.getValue();
  }

  get isSubActive(): boolean {
    this.getAccountNoEvent().then(
      async (resp: Account) => {
        if (resp) {
          return resp.suscription.status == 1;
        }
      },
    );
    return false;
  }

  get isMember(): boolean {
    this.getAccountNoEvent().then(
      async (resp: Account) => {
        if (resp) {
          return resp.isCinematecaMember;
        }
      },
    );
    return false;
  }

  get polentaUrl(): string {
    return this.polenta_url;
  }

  set polentaUrl(url: string) {
    this.polenta_url = url;
  }

  polentaUrlExists(): boolean {
    return this.polentaUrl.length > 0;
  }

  //#region Follow things

  isFollowingAccount(follower: number, followed: number): Observable<boolean> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get<boolean>(`${environment.apiEndpoint}/follow/isFollowing?follower=${follower}&followed=${followed}`, { headers });
  }

  getFollowerAmount(followed: number): Observable<number> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get<number>(`${environment.apiEndpoint}/follow/GetFollowerAmount?followed=${followed}`, { headers });
  }

  getFollowingAmount(follower: number): Observable<number> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get<number>(`${environment.apiEndpoint}/follow/GetFollowingAmount?follower=${follower}`, { headers });
  }

  getFollowers(followed: number): Observable<FollowItem[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get<FollowItem[]>(`${environment.apiEndpoint}/follow/GetFollowers?followed=${followed}`, { headers });
  }

  getFollowing(follower: number): Observable<FollowItem[]> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get<FollowItem[]>(`${environment.apiEndpoint}/follow/GetFollowing?follower=${follower}`, { headers });
  }

  getSmallProfileInfo(id: number): Observable<SmallProfileInfo> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.get<SmallProfileInfo>(`${environment.apiEndpoint}/Account/GetSmallProfileInfo?id=${id}`, { headers });

  }

  addFollow(item: FollowItem): Observable<number> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.post<number>(`${environment.apiEndpoint}/follow/add`, item, { headers });
  }

  deleteFollow(follower: number, followed: number): Observable<number> {
    const headers = new HttpHeaders().set(
      'Authorization',
      `Bearer ${JSON.parse(localStorage.getItem('cinemateca_token'))['token']}`,
    );
    return this.http.delete<number>(`${environment.apiEndpoint}/follow/Delete?follower=${follower}&followed=${followed}`, { headers });
  }

  //#endregion



}
